// extracted by mini-css-extract-plugin
export default {"notfound":"NotFound_notfound__iGl2L","content":"NotFound_content__XsXEr","m404":"NotFound_m404__KucvR","message":"NotFound_message__rV3+2"};